// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__KBFg2","menuList":"Sidebar_menuList__VV7TL","menuItem":"Sidebar_menuItem__EjEuF","menuIcon":"Sidebar_menuIcon__JPXT6","active":"Sidebar_active__X14an"};